import type { MinimumListData } from "../page/content.types.ts";
import axios from "axios";
import type { StoreRootDispatch } from "./storeRoot.ts";

export type StateList = {
	loading: boolean;
	list: MinimumListData[],
	error: string,
}

export type ActionListFetch = StateList & { type: string }

export interface FetchStates {
	Begin: string,
	Success: string,
	Failure: string,
}

export interface FetchActions {
	begin: Function,
	success: Function,
	failure: Function,
}

export function getListEnum(suffix: string): FetchStates {
	return {
		Begin: 'BEGIN_' + suffix,
		Success: 'SUCCESS_' + suffix,
		Failure: 'FAILURE_' + suffix,
	} as FetchStates;
}

export function getListActions(fetchState: FetchStates): FetchActions {
	return {
		begin: () => ({
			type: fetchState.Begin
		}),
		success: (data: object[], id: number) => ({
			type: fetchState.Success,
			list: data,
			id: id
		}),
		failure: (error: any) => {
			console.log('Error ', error);
			return {type: fetchState.Failure, error: error};
		},
	} as FetchActions;
}

export async function getListLoadAction(dispatch: StoreRootDispatch, url: string, fetchState: FetchStates) {
	const actions = getListActions(fetchState);

	dispatch(actions.begin());

	try {
		let response = await axios(url);
		if (typeof response.data === 'object') {
			if (response.data.hasOwnProperty('list') && response.data.hasOwnProperty('count')) {
				dispatch(actions.success(response.data.list));
			} else {
				dispatch(actions.success(response.data));
			}
		} else {
			dispatch(actions.failure(null));
		}
	} catch (error) {
		dispatch(actions.failure(error));
	}
}

export function getListReducer(fetchStates: FetchStates, listInitialValue: any = []) {
	return (state = {list: listInitialValue, loading: false} as StateList, action: ActionListFetch): StateList => {
		switch (action.type) {
			case fetchStates.Begin:
				return {
					...state,
					loading: true,
					error: null // also, reset any errors
				};

			case fetchStates.Success:
				// replace the items with the ones from the server
				return {
					...state,
					loading: false,
					list: action.list,
				};

			case fetchStates.Failure:
				// save the error
				return {
					...state,
					error: action.error,
					loading: false,
					list: []
				};

			default:
				return state
		}
	}
}
